var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpgLoadingDesktopBottom = function SvgEpgLoadingDesktopBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1136,
    height: 380,
    fill: "none",
    viewBox: "0 0 1136 380"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 48,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 48,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 248,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 248,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 98,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 98,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 198,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 198,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 298,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 298,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 148,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 148,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 48,
    x: 2,
    y: 348,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1056,
    height: 48,
    x: 104,
    y: 348,
    rx: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1136v596H0z"
  })))));
};
export default SvgEpgLoadingDesktopBottom;